import styled from "styled-components";
import { Dialog } from "@mui/material";
import Select from "@mui/material/Select";

export const StyledDialog = styled(Dialog)`

  .MuiDialog-paper {
    width: 800px;
    max-width: 800px;
    padding: 32px 40px;
    border-radius: 8px;
  }
`;

export const DialogHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 24px;
  border-bottom: 1px solid ${props => props.theme.colors.dividerGray};
`;

export const HeaderTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DialogTitle = styled.h2`
  font-family: 'Inter';
  font-size: 20px;
  font-weight: 600;
  color: ${props => props.theme.colors.darkBlue};
  margin: 0;
`;

export const DialogDescription = styled.p`
  font-family: 'Inter';
  font-size: 14px;
  font-weight: 400;
  color: ${props => props.theme.colors.davysGrey};
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  color: ${props => props.theme.colors.highClearGray};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DialogContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 16px;
`;

export const SearchContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
`;

export const SearchIconWrapper = styled.div`
  position: absolute;
  left: 12px;
  top: 20px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.colors.grey};
  line-height: 0;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 8px 12px 8px 40px;
  border: 1px solid ${props => props.theme.colors.dividerGray};
  border-radius: 4px;
  font-size: 14px;
  font-family: 'Inter';
  height: 40px;
  
  &::placeholder {
    font-style: italic;
    color: ${props => props.theme.colors.davysGrey};
  }

  &:focus {
    outline: none;
    border-color: ${props => props.theme.colors.celticBlue};
  }
`;

export const UserListContainer = styled.div`
  height: 140px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const UserItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const UserLeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const UserInfo = styled.div`
  display: flex;
  gap: 4px;
`;

export const UserName = styled.span`
  font-family: 'Inter';
  font-size: 14px;
  font-weight: 600;
  color: ${props => props.theme.colors.darkBlue};
`;

export const UserEmail = styled.span`
  font-family: 'Inter';
  font-size: 14px;
  font-weight: 400;
  color: ${props => props.theme.colors.davysGrey};
`;

export const Divider = styled.span`
  color: ${props => props.theme.colors.davysGrey};
  
  &::after {
    content: '|';
  }
`;

export const UserRole = styled.span`
  font-family: 'Inter';
  font-size: 14px;
  font-weight: 400;
  color: ${props => props.theme.colors.davysGrey};
`;

export const UserActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StyledSelect = styled(Select)`
  &.MuiInputBase-root {
    font-family: 'Inter';
    font-size: 14px;
    height: 40px;
    min-width: 100px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 10px;
    
    .MuiSelect-select {
      padding: 16px;
      display: flex;
      align-items: center;
    }
  }
`;

export const DeleteButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: ${props => props.theme.colors.highClearGray};
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: ${props => props.theme.colors.davysGrey};
  }
`;

export const DialogFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  padding-top: 24px;
  border-top: 1px solid ${props => props.theme.colors.dividerGray};
  margin-top: 16px;
`;

export const CancelButton = styled.button`
  height: 40px;
  padding: 8px 16px;
  border-radius: 8px;
  font-family: 'Inter';
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.theme.colors.davysGrey};
  background: transparent;
  border: 1px solid ${props => props.theme.colors.dividerGray};
  cursor: pointer;

  &:hover {
    background: ${props => props.theme.colors.highClearGray};
  }
`;

export const ShareButton = styled.button`
  height: 40px;
  padding: 8px 16px;
  border-radius: 8px;
  font-family: 'Inter';
  font-size: 14px;
  font-weight: 500;
  color: white;
  background: ${props => props.theme.colors.celticBlue};
  border: none;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    background: ${props => props.theme.colors.dividerGray};
    cursor: not-allowed;
  }
`;

export const SearchResults = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid ${props => props.theme.colors.dividerGray};
  border-radius: 8px;
  margin-top: 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
`;

export const SearchResultItem = styled.div`
  padding: 12px 16px;
  cursor: pointer;
  color: ${props => props.theme.colors.darkGray};
  font-size: 14px;

  &:hover {
    background: ${props => props.theme.colors.highClearGray};
  }
`;

export const NoUsersMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: ${props => props.theme.colors.davysGrey};
  font-family: 'Inter';
  font-size: 14px;
  font-style: italic;
`; 

export const SharedUsersLabel = styled.div`
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.15px;
`;

export const SharedUsersCount = styled.div`
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const SharedUsersSection = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.dividerGray};
  padding-top: 24px;
  height: 200px;
  overflow-y: auto;
`;

export const CurrentlySharedUsers = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`; 

export const AddedUsersLabel = styled.div`
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: ${({ theme }) => theme.colors.davysGrey};
`; 